import * as React from "react";
import * as Immutable from "immutable";
import _ from "lodash";
// import { css } from "glamor;"
import { ListItem } from "material-ui/List";
import ChevronIcon from "material-ui/svg-icons/navigation/chevron-left";
import Badge from "material-ui/Badge";
import CustomImageModal from "./custom-image-modal";
import theme from "styles/theme";
import CSS from "csstype";
import { toDataTest } from "helpers/test";

// activeFiltersValues, onChange, field
interface Ifiltervalue {
    __key: string;
    __data: string[];
}

interface IProps {
    filter: Ifiltervalue;
    activeFiltersValues: Immutable.Map<string, any>;
    onChange: (e: any, field?: string, value?: string) => void;
}

interface IState {
    openModal: boolean;
}

class ImageFilter extends React.Component<IProps, IState> {
    styles = {
        listItem: {
            fontSize: "14px",
            fontFamily: "Lato, sans-serif",
            textTransform: "capitalize",
        },
        shortListItemInner: {
            padding: "10px 0px 10px 8px",
        },
        dropdownIcon: {
            top: -6,
        },
        dropdownIconOpen: {
            msTransform: "rotate(-90deg)",
            WebkitTransform: "rotate(-90deg)",
            transform: "rotate(-90deg)",
        },
        badge: {
            top: 6,
            right: 44,
            color: theme.palette.darkerGrey,
            backgroundColor: theme.palette.lightGrey,
        },
        badgeContainer: {
            position: "static",
            padding: "0px",
        },
    };

    constructor(props) {
        super(props);
        this.state = {
            openModal: false,
        };
    }

    handleToggleFilter = () => {
        this.setState({ openModal: !this.state.openModal });
    };

    render() {
        const { filter, activeFiltersValues, onChange } = this.props;
        const memoizedFilterName = _.memoize((value: string) => value.replace("_", " ").toLowerCase());
        const filterKey = filter.__key;
        const filterList = activeFiltersValues.get(filterKey) || Immutable.List();
        const filterListLength = filterList.size;
        const filterName = memoizedFilterName(filterKey);
        const { openModal } = this.state;
        const styles = this.styles;

        // Badge
        let title = <div>{filterName}</div>;
        if (filterList.size > 0) {
            title = (
                <Badge
                    badgeContent={filterList.size}
                    primary={true}
                    style={styles.badgeContainer as React.CSSProperties}
                    badgeStyle={styles.badge}
                >
                    {filterName}
                </Badge>
            );
        }

        return (
            <React.Fragment>
                <ListItem
                    initiallyOpen={openModal}
                    primaryText={title}
                    primaryTogglesNestedList={true}
                    style={styles.listItem as CSS.Properties}
                    onNestedListToggle={this.handleToggleFilter}
                    innerDivStyle={styles.shortListItemInner as CSS.Properties}
                    disabled={false}
                    rightIcon={
                        <ChevronIcon
                            style={{ ...styles.dropdownIcon, ...(openModal && styles.dropdownIconOpen) }}
                            data-test={`chevron-${toDataTest(filter.__key)}`}
                        />
                    }
                />
                <CustomImageModal
                    key={filterListLength}
                    activeFiltersValues={activeFiltersValues}
                    filter={filter}
                    isModalOpen={openModal}
                    closeModal={this.handleToggleFilter}
                    onChange={onChange}
                />
            </React.Fragment>
        );
    }
}

export default ImageFilter;
